import React, { useState } from 'react';
import { Inbox, Wallet, User, ShieldCheck, History } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import ProfileForm from '../../Components/therapist/ProfileForm';
import VerificationUpload from '../../Components/therapist/VerificationUpload';
import OfferInbox from '../../Components/therapist/OfferInbox';
import OrderHistory from '../../Components/therapist/OrderHistory';
import WalletPanel from '../../Components/shared/WalletPanel';
import DashboardShell from '../../Components/shared/DashboardShell';

const NAV_ITEMS = [
  { id: 'offers', label: 'Offers & session', icon: Inbox },
  { id: 'wallet', label: 'Wallet', icon: Wallet },
  { id: 'profile', label: 'Profile', icon: User },
  { id: 'verification', label: 'Verification', icon: ShieldCheck },
  { id: 'history', label: 'Order history', icon: History }
];

const TherapistDashboard = () => {
  const { logout } = useAuth();
  const [activeTab, setActiveTab] = useState('offers');

  return (
    <DashboardShell
      title="Therapist Dashboard"
      navItems={NAV_ITEMS}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      onLogout={logout}
    >
      {activeTab === 'offers' && <OfferInbox />}
      {activeTab === 'wallet' && <WalletPanel />}
      {activeTab === 'profile' && <ProfileForm />}
      {activeTab === 'verification' && <VerificationUpload />}
      {activeTab === 'history' && <OrderHistory />}
    </DashboardShell>
  );
};

export default TherapistDashboard;
